import { Injectable, Injector } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { HelperService } from './helper.service';

@Injectable({
  providedIn: 'root'
})
export class BaseService {
  collectionName: string;
  protected db = this.injector.get(AngularFirestore);
  protected helper = this.injector.get(HelperService);

  constructor(
    protected injector: Injector,
  ) { }

  setBaseCollection(collectionName: string) {
    this.collectionName = collectionName;
  }

  getList() {
    return this.db.collection(this.collectionName).snapshotChanges().pipe(
      switchMap(res => {
        return of(res.map(item => {
          return {
            id: item.payload.doc.id,
            ...item.payload.doc.data() as any
          };
        })) as any;
      })
    );
  }

  create(data) {
    const result = this.helper.removeIdFromObject(data);
    return this.db.collection(this.collectionName).add(result);
  }

  update(data) {
    const result = this.helper.removeIdFromObject(data);
    return this.db.collection(this.collectionName).doc(data.id).set(result);
  }

  remove(id) {
    return this.db.collection(this.collectionName).doc(id).delete();
  }

}
